// extracted by mini-css-extract-plugin
module.exports = {"answer":"Option_answer__cs_OI"};